<template>
	<h2 :class="classes"><slot></slot></h2>
</template>

<script>
export default {
	name: "DISCHeading",
	props: {
		assessment: {
			type: Object,
			required: true,
		},
		border: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		highType() {
			if ( !this.assessment ) {
				return "";
			}
			return this.assessment.moniker[ 0 ].toUpperCase();
		},
		classes() {
			const { highType, border, } = this;
			return {
				"disc-profile-layout-heading": true,
				"disc-profile-layout-heading--bordered": border,
				"disc-profile-layout-heading--default-color": !highType,
				".disc-profile-layout-heading--default-border-color": !highType && border,
				[ `discTextLabel__${ highType }-hightype-label` ]: !!highType,
				[ `discComponent__${ highType }-hightype-border-color` ]: highType && border,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.disc-profile-layout-heading {
	@include font-and-line-for(1);
	text-align: left;
}

.disc-profile-layout-heading--default-color {
	color: $disc-profile-layout-heading-default-color;
}

.disc-profile-layout-heading--default-border-color {
	color: $disc-profile-layout-heading-default-border-color;
}

.disc-profile-layout-heading--bordered {
	border-bottom: 0.0625rem solid;
}
</style>
